export default __webpack_public_path__ + "maps-guides-view-annotation-selected-960-0febbc6f7f79b0148f30a1f8b5c61369.png";